<template>
  <div>
    <div class="d-sm-flex align-items-center justify-content-between mb-4" id="button_user">
      <h1 class="h3 mb-0 text-gray-800 d-inline-block">Order Recruit</h1>
    </div>
    <div class="row" v-show="is_loading">
      <div class="col-3" v-for="i in 4" :key="'skeleton-1-'+i">
        <skeleton-box
          height="41px"
          width="100%"/>
      </div>
      <div class="col-12 mt-3">
        <skeleton-box
          height="24px"
          width="100%"/>
      </div>
      <div class="col-3 mt-3" v-for="i in 4" :key="'skeleton-2-'+i">
        <skeleton-box
          height="50px"
          width="100%"/>
      </div>
      <div class="col-3 mt-3" v-for="i in 4" :key="'skeleton-3-'+i">
        <skeleton-box
          height="50px"
          width="100%"/>
      </div>
      <div class="col-3 mt-3" v-for="i in 4" :key="'skeleton-4-'+i">
        <skeleton-box
          height="50px"
          width="100%"/>
      </div>
    </div>
    <div class="row" v-show="!is_loading">
      <div class="col-12">
        <ul class="nav nav-tabs" id="order_call_tab" role="tablist">
          <li class="nav-item" v-for="(data,index) in arr_type" :key="index" @click="change_type(index)">
            <a :href="'#'+data.data"
              @click="header_tab_clicked(index)"
              class="nav-link"
              :class="{'active': (clicked_header_tab.data == null && index == 0) || (clicked_header_tab.data != null && clicked_header_tab.data == data.data)}"
              :id="data.data+'-tab'"
              data-toggle="tab"
              role="tab"
              :aria-controls="data.data"
              :aria-selected="index == 0 ? 'true' : 'false'">{{ data.name }}</a>
          </li>
        </ul>
        <div class="tab-content" id="order_callTabContent">
          <div class="tab-pane fade"
            :class="{'show active': (clicked_header_tab.data == null && index == 0) || (clicked_header_tab.data != null && clicked_header_tab.data == data.data)}"
            :id="data.data"
            role="tabpanel"
            :aria-labelledby="data.data+'-tab'"
            v-for="(data,index) in arr_type"
            :key="index">
            <div class="mt-3">
              <custom-table
                :arr="data.arr"
                :arr_id="data.arr_id"
                :total_page="data.total_page"
                :url_detail="'/order-recruit/detail'"
                :url_update="'/order-interested/web?status='+arr_type[index].data"
                :url_delete="data.data != 'decline' && data.data != 'wait_review' ? '/order-interested' : null"
                delete_text="Cancel"
                :is_action="data.data == 'wait_refund'"
                :action_text="'Approve'"
                :arr_header="data.arr_header"
                @on_refresh_start="on_refresh_start"
                @on_refresh_end="on_refresh_end"
                @on_action="on_approve"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import custom_table from '@/layout/table'
import table_skeleton from '@/layout/table_skeleton'
import SkeletonBox from '@/layout/skeleton'

export default {
  components:{
    'custom-table': custom_table,
    'table-skeleton': table_skeleton,
    'skeleton-box': SkeletonBox,
  },
  data(){
    return{
      arr_type: [
        {
          data: 'wait',
          name: 'Request Rekrut',
          arr: [],
          total_page: 0,
          arr_header: [],
          arr_id: [],
        },
        {
          data: 'wait_review',
          name: 'Review',
          arr: [],
          total_page: 0,
          arr_header: [],
          arr_id: [],
        },
        {
          data: 'accept',
          name: 'Diterima',
          arr: [],
          total_page: 0,
          arr_header: [],
          arr_id: [],
        },
        {
          data: 'decline',
          name: 'Ditolak',
          arr: [],
          total_page: 0,
          arr_header: [],
          arr_id: [],
        },
        {
          data: 'wait_refund',
          name: 'Menunggu Refund',
          arr: [],
          total_page: 0,
          arr_header: [],
          arr_id: [],
        },
      ],
      clicked_header_tab: {},
      index: 0,
      is_loading: true,
    }
  },
  async created(){
    this.clicked_header_tab = sessionStorage['header_tab_order_call'] != null ? JSON.parse(sessionStorage['header_tab_order_call']) : {}

    if(this.clicked_header_tab != null && this.clicked_header_tab.data != null){
      for(let x in this.arr_type){
        if(this.arr_type[x].data == this.clicked_header_tab.data){
          this.index = x
          break
        }
      }
    }

    await this.get_data(this.index)

    this.is_loading = false
  },
  methods:{
    on_refresh_start(){
      this.is_loading = true
    },
    on_refresh_end(){
      this.is_loading = false
    },
    change_type(index){
      this.index = index
    },
    async on_approve(data){
      try{
        var response = await axios.put(base_url+'/order-interested/refund/approve', data.data)

        var response_data = response.data
        if(response_data.status == "success"){
          this.is_loading = true
          await this.get_data(this.index)
          this.is_loading = false
        }
        else
          this.$toasted.show(response_data.message)
      } catch(e){
        this.$toasted.show(e)
      }
    },
    async header_tab_clicked(index){
      sessionStorage['header_tab_order_call'] = JSON.stringify(this.arr_type[index])
      this.clicked_header_tab = this.arr_type[index]

      await this.get_data(index)
    },
    async get_data(index){
      try{
        var response = await axios.get(base_url+'/order-interested/web?api_type=web-admin&status='+this.arr_type[index].data)

        var response_data = response.data
        if(response_data.status == "success"){
          var data_type = this.arr_type[index]
          data_type.arr = JSON.parse(JSON.stringify(response_data.arr))
          data_type.total_page = response_data.total_page
          data_type.arr_header = response_data.arr_header
          data_type.arr_id = response_data.arr_id
          this.$set(this.arr_type,index,data_type)
        }
        else
          this.$toasted.show(response_data.message)
      } catch(e){
        this.$toasted.show(e)
      }
    },
  }
}
</script>
